/**
 * contiene la información para el manejo de otros tlv.
 */
export const defaultOtrosTlv = () => {
    return {
        id_producto:'',
        idOtroTlv:'',
        sustancia:'',
        nocas : '',
        descripcion:'',
        activo : 1
    }
}

/**
 * contiene la información para el manejo de los filtros de búsqueda y paginación
 */
 export const defaultFiltro = () => {
    return {
        page: 1,
        perPage: 10,
        total: 0,
        sort: 'ASC',
        sortBy: 'id',
        buscar: ''
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedOtrosTlv: defaultOtrosTlv(),
    filtro: defaultFiltro(),
    dataTlv:[],
}
